import { render, staticRenderFns } from "./transition.vue?vue&type=template&id=08d2ed2e&scoped=true"
import script from "./transition.vue?vue&type=script&lang=js"
export * from "./transition.vue?vue&type=script&lang=js"
import style0 from "./transition.vue?vue&type=style&index=0&id=08d2ed2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2ed2e",
  null
  
)

export default component.exports